export default __webpack_public_path__ + "static/media/catlike140000.644f0617.png";